import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { OsUpdate } from '@rocksoft/osupdates-sdk';

export type AvailableOsUpdatesState = EntityState<OsUpdate>;

export function selectId(availableOsUpdate: OsUpdate) {
  return availableOsUpdate.productKey;
}

export const adapter: EntityAdapter<OsUpdate> = createEntityAdapter<OsUpdate>({
  selectId,
});

export const initialState: AvailableOsUpdatesState = adapter.getInitialState();
